import React, { useState, useEffect, useRef } from 'react';

import { useNavigate, useLocation, Link } from 'react-router-dom';

import { motion } from "framer-motion";

import images from '../libs/images';
import consts from '../libs/consts';
import routes from '../libs/routes';

import { usePopup, useUser } from "../zustand/store.js";

import Image from './Image';
import { LangText } from '../zustand/dict.js';

export default function Profile() {

    const location = useLocation();
    const navigate = useNavigate();

    const ref = useRef();
    
    const { profilePop, toggleProfilePop } = usePopup();
    const { user, logout } = useUser();

    useEffect(() => {

        if(profilePop) toggleProfilePop();
        
    }, [location.pathname]);

    useEffect(()=> {
        const handleOutsideClose = (e) => {
            if(profilePop && (!ref?.current?.contains(e.target))) toggleProfilePop();
        };

        document.addEventListener('click', handleOutsideClose);
        
        return () => document.removeEventListener('click', handleOutsideClose);

    }, [profilePop]);

    const logoutFunc = () => {
        // window.Kakao?.Auth.logout();

        toggleProfilePop();
        logout();
        navigate(routes.main);
        window.location.reload();
    }

    return (
        <div
            ref={ref} 
            className={`header_pop ${consts.animationFadeIn}`}
        >
            <Image className={['header_profile']} src={user?.profile ? consts.imgUrl + user?.profile : images.profile} onClick={toggleProfilePop}/>
            <motion.div 
                className='header_pop_box etc_list'
                initial={consts.headerVariants.closed}
                animate={profilePop ? "open" : "closed"}
                variants={consts.headerVariants}
            >
                <div className='top'>
                    <Image className={['header_profile']} src={user?.profile ? consts.imgUrl + user?.profile : images.profile} />

                    <div className='profile_right'>
                        <p className='title'>{user?.email}</p>
                        <Link className='link_text' to={routes.profile}>
                            <LangText id={'profile_settings'} />
                        </Link>
                    </div>
                    
                </div>
                <ul className='list'>
                    <li>
                        <Link className='title link' to={routes.myart_history}>
                            <LangText id={'text_show_my_work'} />
                        </Link>
                    </li>
                    <li>
                        <p className='title link' onClick={logoutFunc}>
                            <LangText id={'logout'} />
                        </p>
                    </li>
                </ul>
            </motion.div>
       </div>
    )    
}
